export enum COMPANY_LEVELS {
  MaxCompaniesLevels = 4
}

export enum COMPANY_INPUT_FIELDS {
  CompanyName = "company name"
}

export enum COMPANY_CARDS_LIMITS {
  MaxResourceCount = 10,
  MaxEmailTransferCount = 5
}
